// Reads the price snapshot in src/data/rates.json (refreshed by
// `node scripts/fetch-rates.js`). Route pages print these as dated example
// prices; live quotes always come from the API.
import RATES from '../data/rates.json';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];

export const checkedText = (() => {
  const [y, m, d] = RATES.checked.split('-').map(Number);
  return `${d} ${MONTHS[m - 1]} ${y}`;
})();

export const checkedYear = RATES.checked.slice(0, 4);

const NAMES = {
  'India Post - EMS': 'India Post Speed Post (EMS)',
  'India Post - Air Parcel': 'India Post Air Parcel',
  'SendMyParcel DDP': 'SendMyParcel DDP (duty paid)',
  'SendMyParcel (Food Items)': 'SendMyParcel (food items)',
};
export const carrierName = (name) => NAMES[name] || name;

export const inr = (n) => `₹${Math.round(Number(n) || 0).toLocaleString('en-IN')}`;

export const country = (key) => RATES.countries[key];

const ratesAt = (key, kg) => country(key).weights[String(kg)] || [];

export const weightsFor = (key) => Object.keys(country(key).weights).map(Number).sort((a, b) => a - b);

export const cheapest = (key, kg, test = () => true) => ratesAt(key, kg).find((r) => test(r.carrier)) || null;

const isExpress = (name) => name === 'DHL' || name === 'FedEx';
export const cheapestExpress = (key, kg) => cheapest(key, kg, isExpress);

export const transitOf = (key, carrier) => {
  for (const kg of weightsFor(key)) {
    const r = ratesAt(key, kg).find((x) => x.carrier === carrier);
    if (r && r.transit) return r.transit;
  }
  return null;
};

// One row per service, one column per weight; ordered by the 1 kg price.
export const rateMatrix = (key) => {
  const weights = weightsFor(key);
  const rows = new Map();
  weights.forEach((kg) => ratesAt(key, kg).forEach((r) => {
    if (!rows.has(r.carrier)) rows.set(r.carrier, { carrier: r.carrier, transit: r.transit, prices: {} });
    const row = rows.get(r.carrier);
    row.prices[kg] = r.price;
    if (!row.transit && r.transit) row.transit = r.transit;
  }));
  const ref = weights.includes(1) ? 1 : weights[0];
  const sortKey = (row) => (row.prices[ref] != null ? row.prices[ref] : Infinity);
  return { weights, rows: [...rows.values()].sort((a, b) => sortKey(a) - sortKey(b)) };
};

// Lowest price per kg anywhere in the table (heavier parcels work out cheaper).
export const lowestPerKg = (key) => {
  let best = null;
  weightsFor(key).forEach((kg) => {
    const r = ratesAt(key, kg)[0];
    if (!r) return;
    const perKg = Math.round(r.price / kg);
    if (!best || perKg < best.perKg) best = { perKg, kg, carrier: r.carrier, price: r.price };
  });
  return best;
};

export const carriersOn = (key) => [...new Set(weightsFor(key).flatMap((kg) => ratesAt(key, kg).map((r) => r.carrier)))];
